/** The one rule for a URL-safe label: lowercase, `a-z0-9-`, nothing else.
 *
 * Shared because two screens type the same kind of value into two different
 * fields — a project's custom domain and an environment's name and domain —
 * and they have to agree on what a keystroke does. They did not: one dropped
 * an invalid character, the other turned whitespace into a hyphen, so the same
 * "My App" became `myapp` in one place and `my-app` in the other.
 *
 * Invalid characters are **dropped, never substituted**. Typing a space is
 * then a keystroke that does nothing, rather than one that quietly inserts a
 * character the user did not ask for — and paired with `sanitizeChange`,
 * nothing moves on screen either.
 *
 * `max` is optional because only some of these fields have a length limit
 * worth enforcing as you type: an environment name is a DNS label with 38
 * characters to spare after its id prefix.
 */
export const slugify = (value: string, max?: number): string => {
  const slug = value.toLowerCase().replace(/[^a-z0-9-]/g, '');
  return max === undefined ? slug : slug.slice(0, max);
};
